import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@frontend/src/App";
import { BrowserRouter } from "react-router-dom";
import { SelfHealingProvider } from "./src/coremodules/selfhealing/components/SelfHealingProvider";
import { initializeThemeMode } from "@seus-ai/theme-f";

if (typeof window !== "undefined") {
    initializeThemeMode();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
    </React.StrictMode>,
);
